import { put } from 'redux-saga/effects';
import { photoCaptureDataFailureAction, photoCaptureIntelligentUpdateBatchStatusAction } from '../actions';
import { IntelligentAssignmentSummary } from '../constants';
/**
 * Saga to update the batch status for upload files iteration
 * @param batch - The array of files included in the batch that was processed
 * @param batchId - The batch ID to update status for
 */
export function* intelligentPhotoCaptureDocumentBatchStatusSaga(batch, batchId) {
    try {
        if (batch.length === 0) {
            throw new Error(IntelligentAssignmentSummary.BATCH_FAILED_TO_UPLOAD);
        }
        yield put(photoCaptureIntelligentUpdateBatchStatusAction(batchId));
    }
    catch (error) {
        yield put(photoCaptureDataFailureAction(error.toString()));
    }
}
//# sourceMappingURL=intelligentPhotoCaptureDocumentBatchStatusSaga.js.map